export default __webpack_public_path__ + "static/media/inspector-text-align-left.93a50ed3.svg";